var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t("select_asset_first")))]),_c('v-btn',{on:{"click":_vm.showAssetSearch}},[_vm._v(_vm._s(_vm.$t("search_device")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }